module.exports = __webpack_public_path__ + "img/essilor.54387f83.png";